import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import CourseHeader from "../components/CourseHeader";
import CourseContent from "../components/CourseContent";
import CourseSidebar from "../components/CourseSidebar";

const BASE_URL = process.env.REACT_APP_API_BASE_URL

const CourseDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("course-info");
  const [courseData, setCourseData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCourseData = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("access");
        const response = await axios.get(`${BASE_URL}/courses/${id}/`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setCourseData(response.data);
        setLoading(false);
      } catch (err) {
        setError("Failed to load course data.");
        setLoading(false);
      }
    };

    fetchCourseData();
  }, [id]);

  if (loading) {
    return <div className="text-center py-5"></div>;
  }

  if (error) {
    return <div className="text-center py-5 text-danger">{error}</div>;
  }

  return (
    <div className="course-detail-container">
      <div className="container-fluid">
      <div className="py-3">
          <i
            className="fas fa-arrow-left"
            style={{ cursor: "pointer", fontSize: "1.25rem" }}
            onClick={() => navigate('/dashboard')}
          ></i>
        </div>
        <div className="row">
          <div className="col-lg-8">
            <CourseHeader course={courseData} />
            <CourseContent course={courseData} activeTab={activeTab} onTabChange={setActiveTab} />
          </div>
          <div className="col-lg-4">
            <CourseSidebar course={courseData} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseDetailPage;